/* eslint-disable */
// GENERATED FILE — DO NOT EDIT.
// Source of truth: TruVisibility.TruForms.Resources/FormPages/MetadataFormPageResources.resx (+ .ru.resx).
// Regenerate with: npm run generate-labels (Web.Client) — runs automatically in build-builder.
export const GENERATED_DEFAULT_LABELS = {
    en: {
    "SUBMIT_BUTTON_LABEL": "send",
    "PREVIOUS_BUTTON_LABEL": "previous",
    "NEXT_BUTTON_LABEL": "next",
    "THANKFUL_PAGE_HEADER": "Thank you!",
    "THANKFUL_PAGE_TEXT": "Your response has been submitted successfully.",
    "WIDGET_SIGN_IN": "Log In",
    "WIDGET_SIGN_UP": "Sign Up",
    "WIDGET_FORGOT_PASSWORD": "Forgot your password?"
},
    ru: {
    "SUBMIT_BUTTON_LABEL": "отправить",
    "PREVIOUS_BUTTON_LABEL": "предыдущая",
    "NEXT_BUTTON_LABEL": "следующая",
    "THANKFUL_PAGE_HEADER": "Спасибо!",
    "THANKFUL_PAGE_TEXT": "Ваш ответ успешно отправлен.",
    "WIDGET_SIGN_IN": "Войти",
    "WIDGET_SIGN_UP": "Зарегистрироваться",
    "WIDGET_FORGOT_PASSWORD": "Забыли свой пароль?"
}
} as const;
